<template>
  <component
    :is="navigationDisabled ? 'div' : NuxtLink"
    :href="navigationDisabled ? null : '/'"
    class="logo-container"
  >
    <StoryblokImg v-bind="{ image }" />
  </component>
</template>

<script lang="ts" setup>
import { NuxtLink } from "#components";
import { AssetStoryblok } from "~/types/bloks";

defineProps<{
  image: AssetStoryblok | { filename: string; alt: string };
  navigationDisabled?: boolean;
}>();
</script>

<style lang="scss" scoped>
.logo-container {
  user-select: none;

  a,
  img {
    display: block;
    width: 100px;

    @media screen and (min-width: $break-xs-min) {
      width: 125px;
    }
  }
}
</style>
